export default "__VITE_ASSET__avaagFWe__"